module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalShow),
      expression: "modalShow"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "title": "流程历史",
      "size": "small"
    },
    domProps: {
      "value": (_vm.modalShow)
    },
    on: {
      "close": function($event) {
        _vm.closeModal()
      },
      "open": function($event) {
        _vm.getFlowHistroy()
      },
      "input": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "flowHistroy-container"
  }, [_c('div', {
    staticClass: "ovf-hd"
  }, [_c('div', {
    staticClass: "fr bor-ra-5 ovf-hd bor-gray"
  }, [_c('div', {
    staticClass: "fl p-t-5 p-l-10 p-b-5 p-r-10 pointer",
    class: {
      'active-tab': _vm.timeActive
    },
    on: {
      "click": function($event) {
        _vm.switchActive(1)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', [_vm._v("时间轴")])]), _vm._v(" "), _c('div', {
    staticClass: "fl p-t-5 p-l-10 p-b-5 p-r-10 pointer",
    class: {
      'active-tab': _vm.listActive
    },
    on: {
      "click": function($event) {
        _vm.switchActive(0)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', [_vm._v("列表")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timeActive),
      expression: "timeActive"
    }],
    staticClass: "contentActive"
  }, _vm._l((_vm.histroyData), function(item, index) {
    return _c('div', {
      staticClass: "m-t-20"
    }, [_c('div', {
      staticClass: "fl w-100 h-60 tx-c pos-rel"
    }, [_vm._v("\n            " + _vm._s(_vm._f("toDate")(item.deal_time)) + "\n            "), (index != _vm.histroyData.length - 1) ? _c('div', {
      staticClass: "time-line"
    }, [_c('div', {
      staticClass: "fa fa-dot-circle-o start"
    }), _vm._v(" "), _c('div', {
      staticClass: "fa fa-dot-circle-o end"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "fl w-150 tx-c"
    }, [_c('div', [_vm._v(_vm._s(item.realname))]), _vm._v(" "), _c('div', [_vm._v("（" + _vm._s(item.post_name) + "）")])]), _vm._v(" "), _c('div', {
      staticClass: "fl m-l-10 bor-ra-5 bg-gra heig-60 w-300 bor-gray ovf-hd pad-6 pos-rel"
    }, [_c('div', {
      staticClass: "w-300 ovf-hd ovf-hd"
    }, [_c('div', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.realname) + "  ")]), _vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "consuming"
    }, [_vm._v(_vm._s(_vm._f("spendTime")((item.deal_time - item.create_time))))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listActive),
      expression: "listActive"
    }],
    staticClass: "m-t-20 contentActive"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.histroyData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "node_name",
      "label": "审批节点",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "办理人",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.realname) + "（" + _vm._s(scope.row.post_name) + "）\n            ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签核动作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("action")(scope.row.examine_status)) + "\n            ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "办理时间"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("toTime")(scope.row.deal_time)) + "\n            ")]
      }
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29062dce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/histroy.vue
// module id = 1798
// module chunks = 2